import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { CheckCircle, Building2, Briefcase } from 'lucide-react';

export default function LandingBenefits({ onRegisterClick }) {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">{t('landing.twoSided.title')}</h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">{t('landing.twoSided.subtitle')}</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-12">
          {/* For Businesses */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border border-slate-200">
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-secondary rounded-xl flex items-center justify-center">
                <Building2 className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-slate-900">{t('landing.twoSided.business.title')}</h3>
                <p className="text-slate-600">{t('landing.twoSided.business.subtitle')}</p>
              </div>
            </div>
            <ul className="space-y-4">
              {[1,2,3,4,5].map((n) => {
                const benefit = t(`landing.twoSided.business.benefit${n}`);
                return (
                  <li key={benefit} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700 text-lg">{benefit}</span>
                  </li>
                );
              })}
            </ul>
            <Button size="lg" onClick={onRegisterClick} className="w-full mt-8 bg-primary hover:bg-primary/90 text-white" data-testid="benefits-business-cta">
              {t('landing.twoSided.business.cta')}
            </Button>
          </div>
          {/* For Vendors */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border border-slate-200">
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-secondary rounded-xl flex items-center justify-center">
                <Briefcase className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-slate-900">{t('landing.twoSided.vendor.title')}</h3>
                <p className="text-slate-600">{t('landing.twoSided.vendor.subtitle')}</p>
              </div>
            </div>
            <ul className="space-y-4">
              {[1,2,3,4,5].map((n) => {
                const benefit = t(`landing.twoSided.vendor.benefit${n}`);
                return (
                  <li key={benefit} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700 text-lg">{benefit}</span>
                  </li>
                );
              })}
            </ul>
            <Button size="lg" onClick={onRegisterClick} className="w-full mt-8 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="benefits-vendor-cta">
              {t('landing.twoSided.vendor.cta')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
